export const UserRoles = {
  ADMIN: 'ADMIN',
  CLARIFICATION: 'CLARIFICATION',
  SMM_OVERVIEW: 'SMM_OVERVIEW',
  DOCUMENT_CLASSIFICATION: 'DOCUMENT_CLASSIFICATION',
  TRANSACTION_DATA_CAPTURE: 'TRANSACTION_DATA_CAPTURE',
  TRANSACTION_DATA_READ: 'TRANSACTION_DATA_READ',
  TRANSACTION_DATA_CAPTURE_QA: 'TRANSACTION_DATA_CAPTURE_QA',
  WARRANT_CAPTURE: 'WARRANT_CAPTURE',
  WARRANT_READ: 'WARRANT_READ',
  CORRECTION_TOOL: 'CORRECTION_TOOL',
};
